var _mask, _path, _path2, _path3, _mask2, _path4, _mask3, _path5, _mask4, _path6, _mask5, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcamBorderLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 340,
    viewBox: "0 0 548 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13042_61910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.9543 12.9543 0 24 0H524C535.046 0 544 8.95431 544 20V320C544 331.046 535.046 340 524 340H24C12.9543 340 4 331.046 4 320V20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.9543 12.9543 0 24 0H524C535.046 0 544 8.95431 544 20V320C544 331.046 535.046 340 524 340H24C12.9543 340 4 331.046 4 320V20Z",
    fill: "url(#pattern0_13042_61910)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.9543 12.9543 0 24 0H524C535.046 0 544 8.95431 544 20V320C544 331.046 535.046 340 524 340H24C12.9543 340 4 331.046 4 320V20Z",
    fill: "url(#pattern1_13042_61910)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0V4H524V0V-4H24V0ZM544 20H540V320H544H548V20H544ZM524 340V336H24V340V344H524V340ZM4 320H8V20H4H0V320H4ZM24 340V336C15.1634 336 8 328.837 8 320H4H0C0 333.255 10.7452 344 24 344V340ZM544 320H540C540 328.837 532.837 336 524 336V340V344C537.255 344 548 333.255 548 320H544ZM524 0V4C532.837 4 540 11.1634 540 20H544H548C548 6.74517 537.255 -4 524 -4V0ZM24 0V-4C10.7452 -4 0 6.74516 0 20H4H8C8 11.1634 15.1634 4 24 4V0Z",
    fill: "white",
    mask: "url(#path-1-inside-1_13042_61910)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13042_61910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 8.95431 12.9543 0 24 0H52V48H4V20Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 6.74517 10.7452 -4 24 -4H52V4H24C15.1634 4 8 11.1634 8 20H0ZM52 48H4H52ZM0 48V20C0 6.74517 10.7452 -4 24 -4V4C15.1634 4 8 11.1634 8 20V48H0ZM52 0V48V0Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13042_61910)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13042_61910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496 0H524C535.046 0 544 8.9543 544 20V48H496V0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 -4H524C537.255 -4 548 6.74517 548 20H540C540 11.1634 532.837 4 524 4H496V-4ZM544 48H496H544ZM496 48V0V48ZM524 -4C537.255 -4 548 6.74517 548 20V48H540V20C540 11.1634 532.837 4 524 4V-4Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13042_61910)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13042_61910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 292H52V340H24C12.9543 340 4 331.046 4 320V292Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 292H52H4ZM52 344H24C10.7452 344 0 333.255 0 320H8C8 328.837 15.1634 336 24 336H52V344ZM24 344C10.7452 344 0 333.255 0 320V292H8V320C8 328.837 15.1634 336 24 336V344ZM52 292V340V292Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13042_61910)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13042_61910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496 292H544V320C544 331.046 535.046 340 524 340H496V292Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 292H544H496ZM548 320C548 333.255 537.255 344 524 344H496V336H524C532.837 336 540 328.837 540 320H548ZM496 340V292V340ZM548 292V320C548 333.255 537.255 344 524 344V336C532.837 336 540 328.837 540 320V292H548Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13042_61910)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13042_61910)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcamBorderLandscape);
export default __webpack_public_path__ + "static/media/webcam_border_landscape.4d96f1d6a47634dbf49c919483f99f6d.svg";
export { ForwardRef as ReactComponent };